var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.records, function (r, i) {
        return _vm.isRecordActive(r)
          ? _c("div", { staticClass: "mb-1" }, [
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _c("div", { staticClass: "input-group-prepend" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: r.int_value,
                            expression: "r.int_value",
                          },
                        ],
                        class: {
                          "form-control": true,
                          not_selected: !r.int_value,
                        },
                        attrs: { disabled: _vm.disableToEdit },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              r,
                              "int_value",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "0", disabled: "" } }, [
                          _vm._v("Выберите страну"),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.$AllCountries, function (c) {
                          return c.is_active
                            ? _c("option", { domProps: { value: c.id } }, [
                                _vm._v(_vm._s(c.name)),
                              ])
                            : _vm._e()
                        }),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.defaultDimensions, function (d) {
                    return [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c("span", { staticClass: "input-group-text" }, [
                          _vm._v(_vm._s(d.abr)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: r.array_value[d.alias],
                            expression: "r.array_value[d.alias]",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "number",
                          disabled: _vm.disableToEdit,
                          placeholder: d.title,
                          "aria-label": d.title,
                        },
                        domProps: { value: r.array_value[d.alias] },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              r.array_value,
                              d.alias,
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group-prepend" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-danger",
                        attrs: { type: "button", disabled: _vm.disableToEdit },
                        on: {
                          click: function ($event) {
                            return _vm.removeDetail(i)
                          },
                        },
                      },
                      [_c("i", { staticClass: "icon-fa icon-fa-trash" })]
                    ),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: r.array_value.comment,
                      expression: "r.array_value.comment",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    disabled: _vm.disableToEdit,
                    placeholder: "комментарий",
                  },
                  domProps: { value: r.array_value.comment },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(r.array_value, "comment", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "input-group-append" }, [
                  _c("span", { staticClass: "input-group-text" }, [
                    _vm._v(_vm._s(_vm.printDate(r.created_at, "DD.MM.YYYY"))),
                  ]),
                ]),
              ]),
            ])
          : _vm._e()
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-jc-between" },
        [
          !_vm.disableToEdit
            ? _c(
                "button",
                {
                  staticClass: "btn btn-outline-info btn-xs",
                  attrs: { type: "button" },
                  on: { click: _vm.addNewRecord },
                },
                [_vm._v("добавить\n      запись\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.updateRecords
            ? _c("LoadingButton", {
                attrs: {
                  title: "сохранить",
                  type: "button",
                  className: "btn btn-outline-success btn-xs",
                  onClick: () => _vm.saveRecords(),
                  loading: _vm.btnLoading,
                  color: _vm.$constants.SUCCESS_COLOR,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }